const BASE_URL = "/api/health-insurance";
export const CREATE_QUOTE_URL = `api/health/create-quote`;
export const GET_BANK_NAME_FOR_OPTIMA_SECURE_URL = `api/hdfc-bank-names/`;
